import React, { Component } from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
import { captureException } from '../services/analytics';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Uncaught financial app error:', error, errorInfo);
    captureException(error, {
      componentStack: errorInfo?.componentStack,
      mechanism: { handled: false }
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const isDev = import.meta.env.DEV;

      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            background: 'var(--bg-primary, #0a0b10)',
            color: 'var(--text-main, #f1f2f6)'
          }}
        >
          <div
            className="glass-panel modal-spring-enter"
            style={{
              padding: '32px 24px',
              maxWidth: '420px',
              width: '100%',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '16px',
              borderRadius: '24px',
              border: '1px solid rgba(255, 71, 87, 0.3)',
              boxShadow: '0 0 30px rgba(255, 71, 87, 0.15)'
            }}
          >
            <div
              style={{
                width: '64px',
                height: '64px',
                borderRadius: '50%',
                background: 'rgba(255, 71, 87, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#ff4757'
              }}
            >
              <AlertTriangle size={36} />
            </div>

            <h2 style={{ fontSize: '20px', fontWeight: '700', margin: 0 }}>
              Application Exception
            </h2>

            <p style={{ fontSize: '13px', color: 'var(--text-muted, #8b92b0)', margin: 0 }}>
              We encountered an unexpected error while processing your financial view. Your data remains safe.
            </p>

            {/* Hide raw technical stack traces in production for security */}
            {this.state.error && (
              <details style={{ textAlign: 'left', width: '100%', fontSize: '11px', color: '#ff7979', background: 'rgba(0,0,0,0.3)', padding: '10px', borderRadius: '10px', overflowX: 'auto' }}>
                <summary style={{ cursor: 'pointer', fontWeight: 'bold', marginBottom: '4px' }}>Developer Mode Debug Log</summary>
                <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {this.state.error.toString()}
                  {'\n'}
                  {this.state.error.stack}
                </pre>
              </details>
            )}

            <div
              style={{
                display: 'flex',
                gap: '12px',
                width: '100%',
                marginTop: '12px'
              }}
            >
              <button
                type="button"
                onClick={this.handleReset}
                className="btn-primary touch-target"
                style={{
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  borderRadius: '14px',
                  fontSize: '14px'
                }}
              >
                <RefreshCw size={16} />
                Retry Request
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
